import { useEffect, useState, useCallback } from "react";
import { LandingPageJobDescription } from "../Entities/job-description.entity";
import { useLoader } from "../Context/LoaderContext/LoaderContext";
import JobDescriptionService from "../Services/job-description.service";
import {
  findAllJobPostDto,
  PositionWithOpeningCount,
} from "../Interface/Index";

interface UseJobPostsReturn {
  jobPosts: LandingPageJobDescription[];
  pageData: {
    total: number;
    totalPages: number;
  };
  positionWithOpeningCount: PositionWithOpeningCount[];
  isFetched: boolean;
}

export const useJobPosts = (filters: findAllJobPostDto): UseJobPostsReturn => {
  const { setLoading, setLoadingMessage } = useLoader();
  const [jobPosts, setJobPosts] = useState<LandingPageJobDescription[]>([]);
  const [pageData, setPageData] = useState<{
    total: number;
    totalPages: number;
  }>({
    total: 0,
    totalPages: 0,
  });
  const [positionWithOpeningCount, setPositionWithOpeningCount] = useState<
    PositionWithOpeningCount[]
  >([]);
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const jobDescriptionService = JobDescriptionService.getInstance();

  const fetchJobPosts = useCallback(async () => {
    try {
      setLoading(true);
      setLoadingMessage("Loading job posts...");

      const result =
        await jobDescriptionService.findAllJobPostWithFiletrsAndPositionCounts(
          filters,
        );
      setJobPosts(result.jobPosts);
      setPageData({
        total: result.pagination.total,
        totalPages: result.pagination.totalPages,
      });
      setPositionWithOpeningCount(result.positionsWithOpeningCount);
    } catch (err: any) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingMessage(null);
      setIsFetched(true);
    }
  }, [filters]);

  useEffect(() => {
    fetchJobPosts();
  }, [fetchJobPosts]);

  return {
    jobPosts,
    pageData,
    positionWithOpeningCount,
    isFetched,
  };
};
